// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1Wa7TKT1qevOJeFrMIaE3w\\=\\= p{color:#666;font-style:italic;padding-top:25px;margin-bottom:0;text-align:left}", "",{"version":3,"sources":["webpack://./src/components/popup/confirm_delete/goal/styles.module.scss"],"names":[],"mappings":"AAEE,+BACE,UAAA,CACA,iBAAA,CACA,gBAAA,CACA,eAAA,CACA,eAAA","sourcesContent":["$prod: true;\n.container {\n  p {\n    color: #666666;\n    font-style: italic;\n    padding-top: 25px;\n    margin-bottom: 0;\n    text-align: left;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "_1Wa7TKT1qevOJeFrMIaE3w=="
};
export default ___CSS_LOADER_EXPORT___;
